var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaseImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4991 23.4406L26.6721 12.1515C25.793 10.0849 24.4821 8.9128 22.9862 8.83569C21.5057 8.75858 20.0715 9.79187 18.9765 11.7659L16.0464 17.025C15.4295 18.1354 14.5505 18.7985 13.5943 18.8756C12.6227 18.9682 11.6511 18.4592 10.8646 17.4568L10.5253 17.025C9.43036 15.6524 8.07323 14.9892 6.68526 15.128C5.29729 15.2668 4.10981 16.223 3.32329 17.7807L0.655311 23.1013C-0.300845 25.0291 -0.208314 27.2654 0.917482 29.0852C2.04328 30.905 4.00186 32 6.1455 32H25.8239C27.8904 32 29.8181 30.9667 30.9593 29.2394C32.1314 27.5121 32.3165 25.3376 31.4991 23.4406Z",
    fill: "#8E9BA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29072 10.4255C11.1696 10.4255 13.5032 8.09165 13.5032 5.21273C13.5032 2.33382 11.1696 0 8.29072 0C5.41189 0 3.07812 2.33382 3.07812 5.21273C3.07812 8.09165 5.41189 10.4255 8.29072 10.4255Z",
    fill: "#8E9BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseImage);
export default __webpack_public_path__ + "static/media/BaseImage.74523bf4cd28c5f2cc65107bcf49fa6c.svg";
export { ForwardRef as ReactComponent };